module.exports = __webpack_public_path__ + "img/badge_color_fia-cost.844fcb82.svg";